export default "__VITE_ASSET__aMvwqZBZ__"